.pce-copy {
	all: unset;
	cursor: pointer;
	position: sticky;
	right: 0.5em;
	top: 0.5em;
	left: 0.5em;
	box-shadow: inset 0 0 0 1px var(--pce-widget-border);
	margin: -9in 0 0 0;
	padding: 0.5em;
	background: var(--pce-widget-bg);
	z-index: 3;
	color: var(--pce-widget-color-options);
	pointer-events: auto;
	display: grid !important;
	align-items: center;
	font: 400 1em/1.5 Arial, Helvetica, sans-serif;
}

.pce-copy,
.pce-copy::after,
.pce-copy::before {
	opacity: 0;
	border-radius: 0.3em;
	transition: opacity 0.1s ease-out;
}

.pce-copy::after {
	content: attr(aria-label);
	position: absolute;
	right: calc(100% + 0.5em);
	background: #000000b3;
	color: #fff;
	text-align: center;
	width: 8ch;
	font-size: 80%;
	padding: 0.2em 0;
	pointer-events: none;
}

.pce-copy::before {
	content: "";
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: #9992;
	box-shadow: inset 0 0 0 1px #999;
}

.prism-code-editor:hover .pce-copy,
.pce-copy:hover::before,
.pce-copy:hover::after {
	opacity: 1;
}

.pce-copy:focus-visible::before,
.pce-copy:focus-visible,
.pce-copy:focus-visible::after {
	opacity: 1;
}
